import React from "react";
import Layout from "layout";
import { useGetApiKeys } from "utils/api/api_keys.api";
import { useGetCurrentAdmin } from "utils/api/admin.api";
import { useApiKeyManagement } from "./hooks/useApiKeyManagement";
import {
  PageHeader,
  ApiKeysTable,
  ApiKeyFormModal,
} from "./components";

const APIs = () => {
  const { data: apiKeys, isLoading } = useGetApiKeys();
  const { data: currentAdmin } = useGetCurrentAdmin();
  
  const {
    formData,
    editingId,
    isModalOpen,
    isSetting,
    handleOpenModal,
    handleCloseModal,
    handleChange,
    handleSubmit,
  } = useApiKeyManagement();

  const isSuperAdmin = currentAdmin?.is_super_admin ?? false;

  return (
    <Layout>
      <div className="dashboard-main">
        <div className="main-wrapper max-w-5xl p-6">
          <PageHeader />

          <ApiKeysTable
            apiKeys={apiKeys}
            isLoading={isLoading}
            isSuperAdmin={isSuperAdmin}
            onEdit={handleOpenModal}
          />
        </div>
      </div>

      <ApiKeyFormModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        formData={formData}
        onChange={handleChange}
        isEditing={!!editingId}
        isLoading={isSetting}
      />
    </Layout>
  );
};

export default APIs;
